import moment from 'moment-timezone'

const getters = {
  getShipmentIsSelecting: (state) => (state.isSelecting),
  getShipmentsContextErrors: (state) => (state.errors),
  getSelectedShipment: (state) => {
    if (state.selectedShipment != null) {
      return state.selectedShipment
    }
    return null
  },
  getIsSelectedShipment: (state) => (shipmentID) => {
    if (state.selectedShipment != null) {
      if (state.selectedShipment.id != null) {
        return state.selectedShipment.id === shipmentID
      }
    }
    return false
  },
  getSelectedShipmentDrops: (state) => {
    if (state.selectedShipment != null) {
      const { units, weight, volume, vehicle, type } = state.selectedShipment
        let numberOfUnits = 0
        if (units != null) {
          numberOfUnits = units.reduce((initValue, { count }) => {
            return initValue + count
          }, 0)
        }
        return {volume, weight, units: numberOfUnits, vehicle, type}
    }
    return null
  },
  getSelectedShipmentStatuses: (state) => {
    if (state.selectedShipment != null) {
      const { status, labels, quotes } = state.selectedShipment
        if (quotes != null) {
          let selectedQuote = quotes.find(({ status }) => (status === 'Accepted'))
          if (selectedQuote != null) {
            return {
              status,
              labels,
              quote: { price: selectedQuote.price, currency: selectedQuote.currency, status: selectedQuote.status }
            }
          } else {
            let currentQuoteStatus = quotes.find(({ status }) => (status === 'Requested'))
            let quoteStatus = null
            if (currentQuoteStatus != null) {
              quoteStatus = currentQuoteStatus.status
            }
            return {
              status,
              labels,
              quote: { price: null, currency: null, status: quoteStatus }
            }
          }
        }
        return { status, labels }
    }
    return null
  },
  getSelectedShipmentSchedule: (state) => {
    if (state.selectedShipment != null) {
      const { schedule } = state.selectedShipment
      if (schedule != null) {
        const startLocation = schedule.stops[0]
        const endLocation = schedule.stops.find(({ stopIndex }) => {
          return stopIndex === schedule.stops.length - 1
        })
        return [startLocation, endLocation]
      }
      return null
    }
    return null
  },
  getSelectedShipmentSchedulePorts: (state) => {
    if (state.selectedShipment != null) {
      const { schedule } = state.selectedShipment
      if (schedule != null) {
        if (schedule.transport != null) {
          const portLocations = schedule.stops.filter(({ type }) => {
            return type != 'LocationPickup' && type != 'LocationDelivery'
          })
          return portLocations
        }
      }
      return null
    }
  },
  getSelectedShipmentScheduleForMap: (state) => {
    if (state.selectedShipment != null) {
      const { schedule } = state.selectedShipment
      if (schedule != null) {
        return schedule.stops
      }
      return null
    }
    return null
  },
  getSelectedShipmentID: (state) => {
    if (state.selectedShipment != null) {
      return state.selectedShipment.id
    }
    return null
  },
  getSelectedShipmentDate: (state) => {
    if (state.selectedShipment != null) {
      const shipmentDay = moment(state.selectedShipment.departureUTC).utc(true).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }).unix()
      return shipmentDay
    }
    return null
  },
  getSelectedShipmentTransportMode: (state) => {
    if (state.selectedShipment != null) {
      if (
        state.selectedShipment.providerName != null
        && state.selectedShipment.type != 'OnePL' && state.selectedShipment.type != 'TwoPL' && state.selectedShipment != 'ThreePL'
        ) {
        return {
          type: state.selectedShipment.type,
          carrier: state.selectedShipment.providerName,
          transportMode: null,
          subtitle: null,
          equipment: null,
          labels: null,
          translate: false
        }
      } else {
        switch (state.selectedShipment.type) {
          case 'OnePL':
            let onePlCarrier = null
            let onePlTransportMode = null
            let onePlModel = null
            let onePlEquipment = null
            let onePlLabels = null
            if (state.selectedShipment.vehicle != null) {
              onePlCarrier = state.selectedShipment.vehicle.organization.name
              onePlTransportMode = `${state.selectedShipment.vehicle.type} ${state.selectedShipment.vehicle.plateNumber}`
              onePlModel = state.selectedShipment.vehicle.model
              onePlEquipment = state.selectedShipment.vehicle.equipment
              onePlLabels = state.selectedShipment.vehicle.labels
            }
            return {
              type: state.selectedShipment.type,
              carrier: onePlCarrier,
              transportMode: onePlTransportMode,
              subtitle: onePlModel,
              equipment: onePlEquipment,
              labels: onePlLabels,
              translate: false
            }
          case 'TwoPL':
            let twoPlCarrier = null
            let twoPlTransportMode = null
            let twoPlEquipment = null
            if (state.selectedShipment.vehicleClass != null) {
              twoPlCarrier = state.selectedShipment.vehicleClass.organization.name
              twoPlTransportMode = state.selectedShipment.vehicleClass.type
              twoPlEquipment = state.selectedShipment.vehicleClass.equipment
            }
            return {
              type: state.selectedShipment.type,
              carrier: twoPlCarrier,
              transportMode: twoPlTransportMode,
              equipment: twoPlEquipment,
              translate: false
            }
          case 'ThreePL':
            let carrier = state.selectedShipment.carrier
            if (state.selectedShipment.quoting != null) {
              if (state.selectedShipment.quoting.selectedQuote != null) {
                carrier = state.selectedShipment.quoting.selectedQuote.organization.name
              }
            } else if (state.selectedShipment.quotes != null) {
              const selectedQuote = state.selectedShipment.quotes.find(({ status }) => {
                return status === 'Accepted'
              })
              if (selectedQuote != null) {
                carrier = selectedQuote.organization.name
              }
            }
            return {
              type: state.selectedShipment.type,
              carrier,
              translate: false
            }
          default:
            return {
              type: null,
              carrier: 'unassigned',
              transportMode: 'select_transport_mode',
              translate: true
            }
        }
      }
    }
    return null
  },
  getListPossibleProviders: (state) => (state.listPossibleProviders),
  getFilteredListPossibleProviders: (state) => {
    if (state.listPossibleProviders != null) {
      let menuFilteredListProviders = [ ...state.listPossibleProviders ]

      // Filtered Quote without price
      menuFilteredListProviders = menuFilteredListProviders.filter(({ __typename, price }) => {
        if (__typename === 'Quote') {
          return price != null
        }
        return true
      })
      if (state.providersMenuFilters != null) {
        menuFilteredListProviders = menuFilteredListProviders.filter(({ __typename }) => {
          return state.providersMenuFilters === __typename
        })
      }
      return menuFilteredListProviders.map((provider) => {
        switch (provider.__typename) {
          case 'OnePLProvider':
            const vehicleEquipment = provider.vehicle.equipment != null ? provider.vehicle.equipment : []
            const vehicleLabels = provider.vehicle.labels != null ? provider.vehicle.labels : []
            return {
              __typename: provider.__typename,
              type: 'Vehicle',
              providerID: provider.vehicle.id,
              organization: {
                name: provider.vehicle.organization.name
              },
              subtitle: `${provider.vehicle.type} ${provider.vehicle.plateNumber}`,
              cost: provider.cost,
              extraSubtitle: `${provider.vehicle.model}`,
              equipment: provider.vehicle.equipment,
              labels: provider.vehicle.labels,
              isOpen: false,
              description: `
                ${provider.vehicle.organization.name} ${provider.vehicle.type} ${provider.vehicle.plateNumber} ${provider.vehicle.model} ${vehicleEquipment.join(' ')} ${vehicleLabels.join(' ')}
              `
            }
          case 'TwoPLProvider':
            const vehicleClassEquipment = provider.vehicleClass.equipment != null ? provider.vehicleClass.equipment : []
            return {
              __typename: provider.__typename,
              type: 'VehicleClass',
              providerID: provider.vehicleClass.id,
              organization: {
                name: provider.vehicleClass.organization.name
              },
              subtitle: `${provider.vehicleClass.type}`,
              cost: provider.cost,
              equipment: provider.vehicleClass.equipment,
              isOpen: false,
              description: `
                ${provider.vehicleClass.organization.name} ${provider.vehicleClass.type} ${vehicleClassEquipment.join(' ')}
              `
            }
          case 'Quote':
            let email = null
            if (provider.contact != null) {
              if (provider.contact.contacts != null) {
                const contactEmail = provider.contact.contacts.find(({ type }) => (type === 'Email'))
                if (contactEmail != null) {
                  email = contactEmail.value
                }
              }
            }
            let cost = null
            if (provider.price != null && provider.currency != null ) {
              cost = {
                price: provider.price,
                currency: provider.currency
              }
            }
            return {
              __typename: provider.__typename,
              type: provider.__typename,
              providerID: provider.quoteID,
              organization: {
                name: provider.organization.name
              },
              status: provider.status,
              subtitle: email,
              cost,
              isOpen: false,
              description: `
                ${provider.organization.name} ${provider.status} ${email}
              `
            }
            case 'Express':
              return {
                __typename: provider.__typename,
                type: provider.__typename,
                providerID: provider.provider.id,
                cost: provider.cost,
                isOpen: false,
                organization: {
                  name: provider.provider.name
                },
                description: `
                  ${provider.provider.name}
                `
                }
          }
      })
    }
    return null
  },
  getIsLoadingProviders: (state) => (state.isLoadingProviders),
  getListPossibleProvidersMenuFilters: (state) => {
    let menuFilters = []
    if (state.listPossibleProviders != null) {
      state.listPossibleProviders.forEach((provider) => {
        const index  = menuFilters.findIndex(({ type }) => (type === provider.__typename))
        if (index < 0) {
          let label = 'internal_fleet'
          switch (provider.__typename) {
            case 'OnePLProvider':
              label = 'internal_fleet'
              break
            case 'TwoPLProvider':
              label = 'contracted_fleet'
              break
            case 'Quote':
              label = 'quote'
              break
            case 'Express':
                label = 'Express'
                break
          }
          menuFilters.push({
            type: provider.__typename,
            label,
            count: 1
          })
        } else {
          menuFilters[index].count += 1
        }
      })
    }
    return menuFilters.length > 0 ? menuFilters : null
  },
  getProvidersCurrentMenuFilters: (state) => (state.providersMenuFilters)
}
export default getters
